import React, { Component } from "react";
import { ICONS } from "../assets/icons";
import { connect } from "react-redux";
import { hideOperacion } from "../redux/actions";
import Reload from "./reload";


class SinInternetModal extends Component {

    state = {
        loading: false
    }

    handleRetryClick = () => {

        this.setState({ loading: true });

        if (navigator.onLine) {
            this.setState({ loading: false });
            this.props.hideOperacion();
        }

        this.setState({ loading: false });
    }

    render() {
        return (
            <div className="row">
                <div className="col s12 center-align mt-2">
                    <img src={ICONS.SIN_INTERNET_64} className="responsive-img" style={{ maxWidth: '50%' }} />
                </div>
                <div className="col s12 center-align siMB mt-1" style={{
                    background: '#F5FBFC',
                    borderTop: 'solid #CCCCCC'
                }}>
                    {
                        this.state.loading ?
                            <Reload /> :
                            <button className="btn primaryBtn mt-3 cursorPointer"
                                onClick={this.handleRetryClick}
                            >Intentar de nuevo</button>
                    }

                </div>
            </div>

        )
    }
}

export default connect(null, { hideOperacion })(SinInternetModal);
